import {z} from '@hono/zod-openapi';

import {ISSUE_REPORT_ATTACHMENT_LIMITS} from './ISSUE_REPORT_ATTACHMENT_LIMITS';
import {issueReportAttachmentSchema} from './IssueReportAttachmentSchema';
import {issueReportDiagnosticsSchema, singleLineText} from './IssueReportDiagnosticsSchema';

// Mirrors `@prompt-bridge/shared/ai-assistant-core`'s ISSUE_REPORT_KINDS /
// ISSUE_REPORT_TITLE_MAX_CHARACTERS / ISSUE_REPORT_DESCRIPTION_MAX_CHARACTERS and its single-line
// title rule. This lib cannot import that package: the `prompt-bridge/shared/validations`
// module-boundary tag forbids ANY workspace-lib dependency (see `.oxlintrc.json` → depConstraints →
// sourceTag "prompt-bridge/shared/validations"), keeping this lib a dependency-free leaf. Keep these
// values in sync by hand if the ai-assistant-core contract changes.
const ISSUE_REPORT_KINDS = ['bug', 'featureRequest'] as const;
const ISSUE_REPORT_TITLE_MAX_CHARACTERS = 150;
const ISSUE_REPORT_DESCRIPTION_MAX_CHARACTERS = 4000;

export const createIssueReportRequestBodySchema = z
  .object({
    kind: z.enum(ISSUE_REPORT_KINDS),
    title: singleLineText(ISSUE_REPORT_TITLE_MAX_CHARACTERS),
    description: z.string().min(1).max(ISSUE_REPORT_DESCRIPTION_MAX_CHARACTERS),
    diagnostics: issueReportDiagnosticsSchema.optional(),
    attachments: z
      .array(issueReportAttachmentSchema)
      .max(ISSUE_REPORT_ATTACHMENT_LIMITS.count)
      .optional(),
  })
  .openapi('CreateIssueReportRequestBody');

export type CreateIssueReportRequestBody = z.infer<typeof createIssueReportRequestBodySchema>;
